// Import Configs
import { CRMRequestService, getCancelableRequest, postCancelableRequest } from './http.config';
// Import Helpers
import { generateCleanUrlParams } from 'services/Helpers';
// Import Types
import type { DataWithPaging, PromotionListItem, IdName, EfficiencyReport } from 'types';

const PromotionHttpService = {
    getPromotionList: () => {
        return postCancelableRequest<DataWithPaging<PromotionListItem>>({
            requestService: CRMRequestService,
            endpointPath: () => '/Promotion/List',
        });
    },
    setPromotionIsPublic: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: ({ isPublic }) => `/Promotion/SetIsPublic?isPublic=${isPublic}`,
        });
    },
    getPromotionEfficiencyReport: () => {
        return getCancelableRequest<EfficiencyReport>({
            requestService: CRMRequestService,
            endpointPath: ({ promotionId, promotionType }) =>
                `/Promotion/GetPromotionEfficiencyResult${generateCleanUrlParams({ promotionId, promotionType })}`,
        });
    },
    getPromotionEfficiencyMetrics: () => {
        return getCancelableRequest<IdName[]>({
            requestService: CRMRequestService,
            endpointPath: () => '/Promotion/GetPromotionEfficiencyMetric',
        });
    },
};

export default PromotionHttpService;
